import { observable } from "mobx";
import { IFullComponent, IComponentService, IComponentType } from "../_types/interfaces";
import i18n from 'i18next';
import { componentService } from "../_services";
import { FilterType } from "../_types/enums/FilterType";
import { ComponentType } from "../_types/enums/ComponentType";

const translate = (name: string) => i18n.t('components.notification.' + name);

export const componentStore = observable({
    loading: false,
    uriService: "",
    services: [] as Array<IComponentService>,
    installService: [] as Array<IComponentService>,
    plugins: [] as Array<IComponentService>,
    installPlugins: [] as Array<IComponentService>,
    isNotification: false,
    fullComponents: [] as Array<IFullComponent>,
    countException: 0,
    message: "",
    isError: false,
    loadStatus: false,
    loadStatusInterval: null as any,
    filter: FilterType.None,
    showMessage(message: string) {
        this.message = message;
        this.isNotification = true;
    },

    async JoinComponents (components: Array<IComponentType> ){
        const full = new Map<string, IFullComponent>(
            this.fullComponents.map(m => [m.name, m]));
        components?.forEach(f => {
            let comp = Join(f, full.get(f.name));
            full.set(f.name, comp);
        });
        this.fullComponents = Array.from(full.values());
    },

    async getAddress() {
        this.loading = true;
        try {
            const response = await componentService.getAddress();
            this.uriService = response;
        }
        catch (errors) {
            this.isError = true;
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async loadServices() {
        this.loading = true;
        try {
            const responseGetInstallServices = 
                await componentService.getInstallServices();
            this.installService = responseGetInstallServices;
            this.JoinComponents(responseGetInstallServices.map(m => (
                {
                    name : m.name,
                    version: m.version,
                    type: ComponentType.Install,
                }) as IComponentType
            ))
            if(!this.isError)
            {
                const responseGetServices = 
                    await componentService.getServices(componentStore.uriService);
                this.services = responseGetServices;
                this.JoinComponents(responseGetServices.map(m => (
                    {
                        name : m.name,
                        version: m.version,
                        type: ComponentType.New,
                    }) as IComponentType
                ))
            }
        }
        catch (errors) {
            this.isError = true;
            this.showMessage(translate('connection_error'));
        }
        this.loading = false;
    },
    async loadPlugins() {
        this.loading = true;
        try {
            const responseGetInstallPlugins = 
                await componentService.getInstallPlugins();
            this.installPlugins = responseGetInstallPlugins;
            this.JoinComponents(responseGetInstallPlugins.map(m => (
                {
                    name : m.name,
                    version: m.version,
                    type: ComponentType.Install,
                }) as IComponentType
            ))
            if(!this.isError)
            {
                const responseGetPlugins = 
                    await componentService.getPlugins(this.uriService);
                this.plugins = responseGetPlugins;
                this.JoinComponents(responseGetPlugins.map(m => (
                    {
                        name : m.name,
                        version: m.version,
                        type: ComponentType.New,
                    }) as IComponentType
                ))
            }
        }
        catch (errors) {
            this.isError = true;
            this.showMessage(translate('connection_error'));
        }
        this.loading = false;
    },
    async addComponents(names: Array<string>, offlineInstall: boolean) {
        this.loading = true;
        try {
            await componentService.addServices(names);
            if(!offlineInstall)
                this.loadStatusInterval = setInterval(() => this.checkUpdateLoadStatus(), 1000) as any;
        }
        catch (errors) {
            this.showMessage(translate('add_error'));
        }
        this.loading = false;
    },

    async deleteComponents(names: Array<string>) {
        this.loading = true;
        try {
            await componentService.deleteServices(names);
            this.loadStatusInterval = setInterval(() => { this.checkDeleteLoadStatus()}, 100) as any;
        }
        catch (errors) {
            this.showMessage(translate('delete_error'));
        }
        this.loading = false;
    },

    async loadUpdates() {
        this.loading = true;
        try {
            const response = await componentService.getUpdateServices();
            this.services = response.services;
            this.JoinComponents(response.services?.map(m => (
                {
                    name : m.name,
                    version: m.version,
                    type: ComponentType.Update,
                }) as IComponentType
            ));
        }
        catch (errors) {
            this.showMessage("Ошибка загрузки обновлений");
        }
        this.loading = false;
    },
    async downloadFiles(names: Array<string>) {
        this.loading = true;
        try {
            await componentService.updateServices({ 
                services: names.map(m => {return {name: m, action: "install"}})
            });
            this.loadStatusInterval = setInterval(() => this.checkUpdateLoadStatus(), 1000) as any;
        }
        catch (error) {
            this.showMessage(translate('download_error'));
        }
        this.loading = false;
    },
    async sendRequestDownloadService() {
        this.loading = true;
        try {
            await componentService.requestDownloadService();
            this.loadStatusInterval = setInterval(() => { this.checkDownloadLoadStatus()}, 100) as any;
        }
        catch (errors) {
        }
        this.loading = false;
    },

    async checkDownloadLoadStatus() {
        this.loadStatus = await componentService.checkDownloadLoadStatus();
        if(this.loadStatus)
            return;
        clearInterval(this.loadStatusInterval);
        await this.loadUpdates();
        
        
    },

    async checkUpdateLoadStatus() {
        try
        {
            this.loadStatus = await componentService.checkUpdateLoadStatus();
        }
        catch
        {
            this.countException += 1;
        }
        if(this.countException > 360)
            this.loadStatus = false;
        if(this.loadStatus)
            return;
        clearInterval(this.loadStatusInterval);
        if(this.countException > 360)
            this.showMessage("Возникла ошибка обратитесь в службу поддержки");
        else
        {
            this.fullComponents = [];
            await this.loadServices();
            await this.loadPlugins();
            await this.loadUpdates();
        }
    },

    async checkDeleteLoadStatus() {
        this.loadStatus = await componentService.checkDeleteLoadStatus();
        if(this.loadStatus)
            return;
        clearInterval(this.loadStatusInterval);
        this.fullComponents = [];
        await this.loadServices();
        await this.loadPlugins();
        await this.loadUpdates();
        
        
    },

    get getFullComponents(): Array<IFullComponent> {
        if (this.filter == FilterType.Update)
            return this.fullComponents.filter(f => f.newVersion && f.currentVersion)
        if (this.filter == FilterType.Install)
            return this.fullComponents.filter(f => !f.currentVersion)
        if (this.filter == FilterType.Delete)
            return this.fullComponents.filter(f => f.currentVersion)
        
        return this.fullComponents;
    },
});

const Join = (newComponent: IComponentType, component: IFullComponent | undefined) =>
    {
        if(component == null)
        {
            if(newComponent.type == ComponentType.Install)
                return ({
                        name : newComponent.name,
                        currentVersion: newComponent.version,
                    }) as IFullComponent;
            else //(newComponent.type == ComponentType.New)
                return ({
                    name : newComponent.name,
                    newVersion: newComponent.version,
                }) as IFullComponent;
        }
        if(newComponent == null)
            return component;
        if(newComponent.type == ComponentType.Update)
            component.newVersion = newComponent.version;
        if(component?.newVersion != null && newComponent.version != null && newComponent.type == ComponentType.Install)
        {
            component.currentVersion = newComponent.version;
            component.newVersion = undefined;
        }
        return component;
    };